import { render, staticRenderFns } from "./CheckBoxConfiguration.vue?vue&type=template&id=6bd4fc9b&"
import script from "./CheckBoxConfiguration.vue?vue&type=script&lang=js&"
export * from "./CheckBoxConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports